export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    isGyseGridOpen: state => state.gyseGridIsOpen,
    isGyseFormOpen: state => state.gyseFormIsOpen,
    getGyseActions: state => state.gyseActions,
    getGyseFormActions: state => state.gyseFormActions,
    getGyseRowActions: state => state.gyseRowActions,
    getGyseHeaderFields: state => state.gyseHeaderFields
}
